var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardSubTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55078 3.92969V7.4769C1.55078 8.27925 2.20122 8.92969 3.00357 8.92969H6.55078",
    stroke: "#868686",
    strokeWidth: 0.66,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.27578,
    y: 7.65469,
    width: 2.55,
    height: 2.55,
    rx: 0.475,
    stroke: "#868686",
    strokeWidth: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.275781,
    y: 0.654687,
    width: 2.55,
    height: 2.55,
    rx: 0.475,
    stroke: "#868686",
    strokeWidth: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSubTask);
export default __webpack_public_path__ + "static/media/CardSubTask.1dbebf15ad927a96824df4037e2c8734.svg";
export { ForwardRef as ReactComponent };